<template>
  <div class="ep-user__container">
    <div class="a-container-form ">
      <div class="a-label ">{{$t('form.signature.name')}}:</div>
      <p class="a-input a-input--disabled ">ЭЦП-{{serial}}</p>
      <span type="button" class="gui-btn-none-style" @click="onSignatureCheckClick" v-if="signature.hasSign">
        <img class="accreditation__reg-img" src="@/assets/img/static/b-icon_edit.svg" alt="">
      </span>
    </div>
    <div class="a-container-form ">
      <div class="a-label ">{{$t('form.signature.status')}}:</div>
      <div class="a-input a-input--disabled u-width-100">
        <div class="accreditation__select-textarea a-form-field">
          <template v-if="canEditFields">
            <dropdown-new class="accreditation__status" v-model="elem.state">
              <option :value="enums.SignatureState.DRAFT" :label="'accreditation-state.draft'" disabled></option>
              <option :value="enums.SignatureState.PROCESSING" :label="'accreditation-state.processing'" disabled></option>
              <option :value="enums.SignatureState.APPROVED" :label="'accreditation-state.approved'"></option>
              <option :value="enums.SignatureState.DECLINED" :label="'accreditation-state.declined'"></option>
              <option :value="enums.SignatureState.NOT_ACTIVE" :label="'accreditation-state.not-active'" disabled></option>
            </dropdown-new>
            <span class="a-validation-error" v-if="$v.elem.state.$dirty && !$v.elem.state.validState">{{$t('form.signature.request-should-be-approved-or-declined')}}</span>

            <textarea class="a-textarea accreditation__textarea"
                      rows="2"
                      :placeholder="$t('labels.reason-for-rejection')"
                      v-if="canEditFields && elem.state == enums.SignatureState.DECLINED"
                      v-model="elem.reason">
            </textarea>
            <span class="a-validation-error" v-if="$v.elem.reason.$dirty && !$v.elem.reason.required">{{$t('labels.mandatory-field')}}</span>
          </template>

          <template v-else>
            <p class="a-input a-input--disabled ">{{$t(signature.state.label)}}</p>
            <div v-if="signature.state == enums.SignatureState.DECLINED">
              <div class="accreditation__error-doc">{{$t('labels.reason')}}: {{signature.reason}}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="a-container-form ">
      <div class="a-label ">{{$t('form.accreditation.due-date')}}:</div>
      <date-time class="a-input a-input--disabled" :time="false" :value="signature.expirationDate"></date-time>
    </div>
    <div class="personal-data__btn-block ">
      <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" v-if="canShowSaveButton" @click="onSaveClick">{{$t('buttons.save')}}</button>
      <button class="gui-btn gui-btn--red gui-btn--w-140" style="margin-right: 20px;" type="button" v-if="canShowModifyButton" @click="editable = true">{{$t('buttons.modify')}}</button>
      <button class="gui-btn gui-btn--white-border gui-btn--w-140" type="button" v-if="canShowCancelButton" @click="onCancelClick">{{$t('buttons.cancel')}}</button>
    </div>
    <signature-details-dialog ref="signCheck"></signature-details-dialog>
  </div>
</template>

<script>
  import { requiredIf } from '@/validators'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import _ from 'lodash'

  export default {
    props: {
      profile: Object,
      signature: Object,
      serial: Number
    },

    components: {
      SignatureDetailsDialog
    },

    data: () => ({
      elem: undefined,
      editable: false,
      reason: undefined
    }),

    computed: {
      canEditFields() {
        return this.signature.permissions.CAN_CHANGE_DIRECTLY || (this.signature.permissions.CAN_CHANGE_WITH_MODIFY && this.editable);
      },

      canShowSaveButton() {
        return this.signature.permissions.CAN_CHANGE_DIRECTLY || this.editable;
      },

      canShowModifyButton() {
        return this.signature.permissions.CAN_CHANGE_WITH_MODIFY && !this.editable;
      },

      canShowCancelButton() {
        return this.signature.permissions.CAN_CHANGE_DIRECTLY || this.editable;
      }
    },

    created() {
      this.elem = _.cloneDeep(this.signature);
    },

    validations: {
      elem: {
        state: {
          validState: function(value) {
            const values = [this.enums.SignatureState.APPROVED, this.enums.SignatureState.DECLINED];
            const idx = values.indexOf(value + '');
            return idx !== -1;
          }
        },
        reason: {
          required: requiredIf(function () {
            return this.elem.state + '' === this.enums.SignatureState.DECLINED
          })
        }
      }
    },

    methods: {
      onCancelClick() {
        this.elem = _.cloneDeep(this.signature);
        this.editable = false;
        this.$v.$reset();
      },

      onSaveClick() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runAction(async () => {
          try {
            await this.$store.dispatch('updateSignatureState', {
              userId: this.profile.id,
              signId: this.signature.id,
              state: this.elem.state.valueOf(),
              reason: this.elem.reason
            });
          }
          catch(e) {
            console.error('unable to update accreditation state', e);
          }

          this.onCancelClick();
        });
      },

      async onSignatureCheckClick() {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkSignature', {
              userId: this.profile.id,
              signId: this.signature.id
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('unable to check signature', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
